
<div class="file-environment-panel">
  <div
    v-for="(item, index) in mountedConfigList"
    :key="`file-env-${index}`"
    class="grid grid-cols-4 gap-x-2 pb-3"
  >
    <v-autocomplete
      :id="`rde-input-file-env-name-${index}`"
      v-model="item.name"
      :items="genOptions(item.name)"
      :label="`* ${$t('workspace_rde.rde_detail.label.resource_name')}`"
      small-chips
      :placeholder="$t('workspace_rde.rde_detail.placeholder.resource_name')"
      class="app-g-autocomplete-v2 v-auto-help-message"
      outlined
      dense
      :rules="[rules.required]"
      :messages="
        item.name
          ? `${$t('common.base.label.type')}: ${item.mountedType}, ${$t(
              'workspace_rde.rde_detail.message.config_type',
            )}: ${item.configType}`
          : ''
      "
      @change="(value) => onResourceNames(item, value)"
    />
    <v-icon class="h-6 w-5 pt-5" @click="handleRemoveClick(index)">
      mdi-close
    </v-icon>
  </div>
  <Button class="add-button" size="md" @click="handleAddClick">
    <v-icon>mdi-plus</v-icon>
    {{ $t("workspace_rde.rde_detail.button.add_file_env_mount") }}
  </Button>
</div>
